import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

// Pages
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Classrooms from './pages/Classroom';
import ClassroomDetail from './pages/ClassroomDetail';
import Quizzes from './pages/Quizzes';
import QuizAttempt from './pages/QuizAttempt';
import QuizDetail from './pages/QuizDetail';
import QuizResult from './pages/QuizResult';
import EditQuiz from './pages/EditQuiz';
import StudentQuizResult from './pages/StudentQuizResult';
import Leaderboard from './pages/Leaderboard';
import CreateQuiz from './pages/CreateQuiz';
import CreateClassroom from './pages/CreateClassroom';
import ForgotPassword from './pages/ForgotPassword';



const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="classrooms" element={<Classrooms />} />
                <Route path="classrooms/:id" element={<ClassroomDetail />} />
                <Route path="quizzes" element={<Quizzes />} />
                <Route path="quizzes/create" element={<CreateQuiz />} />
                <Route path="quizzes/:id" element={<QuizDetail />} />
                <Route path="quizzes/:id/edit" element={<EditQuiz />} />
                <Route path="quizzes/:id/view-result" element={<StudentQuizResult />} />  
                <Route path="quizzes/:id/attempt" element={<QuizAttempt />} />
                <Route path="quizzes/:id/result" element={<QuizResult />} />
                <Route path="leaderboard/:type/:id" element={<Leaderboard />} />
                <Route path="classrooms/create" element={<CreateClassroom />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

